<template>
  <div v-if="rateActiveService" :class="$route.name === 'SubCategories'?'rate-tab-menu container':'rate-tab container'">
    <div v-if="ratingTab" class="text-left">
      <v-chip color="primary" label @click="actionToRateExp()">
        <i :class="'mr-2 fa-solid' + (openRateTab ? ' fa-chevron-down' : ' fa-chevron-up')"></i>
        <span v-if="(instance.rate_nps && !instance.rate_digitalmenu) || (instance.rate_nps && instance.rate_digitalmenu)" v-html="$t('rate-on-table.exp_rate')" />
        <span v-if="(!instance.rate_nps && instance.rate_digitalmenu)" v-html="$t('rate-on-table.menu_rate')" />
      </v-chip>
      <v-sheet
        color="primary"
        height="10"
        cols="12"
      />
    </div>
    <v-card v-if="openRateTab" tile elevation="0">
      <v-card-title class="pb-0 text-center justify-center text-sm-body-2">
        <span v-if="(instance.rate_nps && !instance.rate_digitalmenu) || (instance.rate_nps && instance.rate_digitalmenu)" v-html="$t('rate-on-table.exp_rate')" />
        <span v-if="(!instance.rate_nps && instance.rate_digitalmenu)" v-html="$t('rate-on-table.menu_rate_title')" />
      </v-card-title>
      <v-card-actions class="text-center pt-0 pb-5 justify-center">
        <v-rating length="10">
          <template v-slot:item="props">
            <v-icon
              class="pa-1"
              :color="props.isFilled ? 'amber accent-3' : 'grey lighten-1'"
              v-html="`mdi-numeric-${props.index + 1}-box`"
              @click="props.click(openModalRate(props.index + 1))"
            />
          </template>
        </v-rating>
      </v-card-actions>
    </v-card>
    <rate-modal v-if="modalRate" :data="dataRate" :profile="profile" :flatTypeForm="flatTypeForm" :typeformData="typeformData" @closeRateModal="closeRateModal()" @closeTabRate="closeTabRate()" />
    <rate-msj v-if="msjDialog" :messagesModal="messagesModal" />
  </div>
</template>

<script>
import { mapState, mapMutations,mapGetters } from "vuex";
import { SupplierSurveyService } from "@/services/supplier-surveys";

export default {
  name: "RateTab",
  components: {
    RateModal: () => import(/* webpackChunkName: "RateModal" */  './RateExpMenuModal.vue'),
    RateMsj: () => import(/* webpackChunkName: "RateMsj" */  './RateMsj.vue')
  },
  data() {
    return {
      modalRate: false,
      openRateTab: false,
      dataRate: {
        rateExpSponsor: 0,
        rateMenuDigital: 0,
        rate_digitalmenu: false,
        rate_nps: false,
        comment: "",
        name: "",
        phone: "",
        email: ""
      },
      flatTypeForm: false,
      msjDialog: false,
      messagesModal: null,
      ratingTab: true
    };
  },
  computed: {
    ...mapState('shared', ['typeformData']),
    ...mapState('customer', ['instance', 'supplier']),
    ...mapState('profile',['session','profile']),
    ...mapState('order', ['service','subservice']),
    ...mapState('template', ['template']),
    ...mapGetters('customer', ["is_ontable_basic"]),
    rateActiveService () {
      return this.is_ontable_basic &&
        (this.service === 'on_table' && this.subservice !== 'room') &&
        !this.template.loading && (this.$route.name === 'OnTableHome' || this.$route.name === 'SubCategories') &&
        (this.instance.rate_digitalmenu || this.instance.rate_nps)
    }
  },
  watch: {
    openRateTab(val) {
      if (!val && !this.ratingTab) this.initIntervalTab();
    }
  },
  created() {
    this.initIntervalTab();
    if (this.$route.query.qualification) {
      this.openRateTab = true;
      this.modalRate = true;
      this.openModalRate(0)
    };
  },
  methods: {
    ...mapMutations('shared', ['setTypeFormInfo']),
    closeTabRate() {
      this.hideRatingTag();
      this.watchModalMessages();
    },
    closeRateModal() {
      this.modalRate = false;
      this.openRateTab = false;
      this.dataRate = {};
    },
    watchModalMessages () {
      this.messagesModal = this.$t('rate-on-table.thanks_label');
      this.msjDialog = true;
      setTimeout(() => {
        this.messages = null;
        this.msjDialog = false;
      }, 2000)
    },
    openModalRate(value) {
      let rateExpSponsor,rateMenuDigital =  0;
      if (!this.instance.rate_nps && this.instance.rate_digitalmenu) rateMenuDigital = value;
      else if ((this.instance.rate_nps && !this.instance.rate_digitalmenu) || (this.instance.rate_nps && this.instance.rate_digitalmenu)) rateExpSponsor = value;
      this.dataRate = {
        rateExpSponsor: rateExpSponsor,
        rateMenuDigital: rateMenuDigital,
        rate_digitalmenu: this.instance.rate_digitalmenu,
        rate_nps: this.instance.rate_nps
      };
      this.modalRate = true;
    },
    actionToRateExp() {
      if (this.flatTypeForm) this.modalRate = true;
      else this.openRateTab = !this.openRateTab;
    },
    initIntervalTab() {
      if (this.$route.name === 'OnTableHome' && !this.openRateTab) {
        setTimeout(() => {
          if (!this.flatTypeForm && this.ratingTab) this.openRateTab = true;
        }, 60000);
      };
    },
    async getActiveTypeForm () {
      try {
        let service = 'on_table';
        const responseActivesForms = await SupplierSurveyService.getSupplierSurveysHideRate(service);
        if (responseActivesForms) {
          this.flatTypeForm = true;
          this.getTypesForm(service);
        } else {
          this.flatTypeForm = false;
        };
      } catch (error) {
        (error);
      };
    },
    async getTypesForm (service) {
      try {
        const responseTypeForm = await SupplierSurveyService.getSupplierSurveys(service);
        if (responseTypeForm) this.setTypeFormInfo(responseTypeForm.data);
      } catch (error) {
        console.error(error);
      };
    },
    hideRatingTag () {
      this.ratingTab = false;
    }
  },
  mounted() {
    this.getActiveTypeForm();
  }
};
</script>